export default {
  // apiServerUrl: 'https://dev.bookero.pl',
  apiServerUrl: 'https://internal.bookero.org',
  // apiServerUrl: 'http://bookero-web.localhost:8888',
  // pluginServerUrl: 'https://dev.bookero.pl',
  pluginServerUrl: 'https://cdn.bookero.org',
  // pluginServerUrl: 'http://bookero-web.localhost:8888',
  registrationEnabled: true,
  notificationsEnabled: true,
  isBeta: false,
  uiLanguage: 'en',
  fbIntegrationEnabled: true,
  ga4Enabled: true,
  helpEnabled: false,
  appVersion: '2.5'
}



// WEBPACK FOOTER //
// ./src/env.js